function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M74.6588 26.1579V14.7368C74.6588 10.6842 71.343 7.36842 67.2904 7.36842H37.8167L30.4483 0H8.34303C4.2904 0 0.974609 3.31579 0.974609 7.36842V51.5789C0.974609 55.6316 4.2904 58.9474 8.34303 58.9474H34.8693C39.2904 65.5789 47.3957 70 56.2378 70C70.6062 70 82.0272 58.5789 82.0272 44.2105C82.0272 37.2105 79.0799 30.9474 74.6588 26.1579ZM31.5536 51.5789H8.34303V14.7368H67.2904V21C63.9746 19.1579 60.2904 18.4211 56.2378 18.4211C41.8693 18.4211 30.4483 29.8421 30.4483 44.2105C30.4483 46.7895 30.8167 49.3684 31.5536 51.5789ZM56.2378 62.6316C45.922 62.6316 37.8167 54.5263 37.8167 44.2105C37.8167 33.8947 45.922 25.7895 56.2378 25.7895C66.5536 25.7895 74.6588 33.8947 74.6588 44.2105C74.6588 54.5263 66.5536 62.6316 56.2378 62.6316ZM59.922 36.8421H52.5536V29.4737H59.922V36.8421ZM59.922 58.9474H52.5536V40.5263H59.922V58.9474Z"
});

function SvgIconNoInformationFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 70,
    viewBox: "0 0 83 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoInformationFound);
export default __webpack_public_path__ + "static/media/icon_no_information_found.139f7389.svg";
export { ForwardRef as ReactComponent };